import { NEW_ORGANIZATION } from "@constants/global";
import { useWindowSize } from "@react-hook/window-size";
import RegisterForm from "components/Modal/Register/RegisterForm";
import LeftImagePublic from "components/Pages/LeftImagePublic/LeftImagePublic";
import ToggleLang from "components/ToggleLang/ToggleLang";
import ToggleTheme from "components/ToggleTheme/ToggleTheme";

import { useUserStoreContext } from "context/userStore/userStore.provider";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { PUBLIC_ROUTES } from "routes/routes";
import { Col, Row } from "rsuite";
import { Button } from "components/ui/v2";
import LoginForm from "../Login/Form";
import OrganizationForm from "./components/NewVendor/OrganizationForm";

type TStep1Mode = "register" | "login";

export default function NewOrganizationClassic() {
  const { t } = useTranslation("common");
  const [step1Mode, setStep1Mode] = useState<TStep1Mode>("register");
  const [stepIndex, setStepIndex] = useState<number>(1);

  const { user, signoutNewOrganization } = useUserStoreContext((store) => ({
    ...store,
  }));

  const router = useRouter();
  const wSize = useWindowSize();
  const isMd = wSize[0] > 768;

  useEffect(() => {
    if (user && stepIndex === 1) {
      setStepIndex(2);
    }
  }, [user]);

  const handleCallback = (error?: string) => {
    if (!error) {
      setStepIndex(stepIndex + 1);
    } else {
      toast.error(error);
    }
  };

  return (
    <Row className="relative m-0 h-screen p-0">
      {/* logged as */}
      {user && user?.email && step1Mode === "register" && (
        <div
          className={
            isMd
              ? "absolute right-0 top-0 p-4"
              : "absolute bottom-5 right-5 p-4"
          }
        >
          <span>{t("Logged as")}</span>
          <span className="ml-2 font-bold">{user?.email}</span>
          <Button
            className="z-50 ml-2 cursor-pointer"
            variant="ghost"
            onClick={() => signoutNewOrganization()}
          >
            {t("Cerrar sesión")}
          </Button>
        </div>
      )}
      <Col
        xs={24}
        sm={24}
        md={10}
        className="h-2/6 p-0 lg:h-screen"
        style={{
          height: isMd ? "100vh" : "30vh",
        }}
      >
        <LeftImagePublic
          {...{
            backgroundsvg: NEW_ORGANIZATION,
          }}
        />
      </Col>
      <Col
        xs={24}
        sm={24}
        md={14}
        className="animate__animated animate__fadeIn flex flex-col items-center justify-center md:pt-12 lg:h-screen lg:pt-0"
      >
        <div className="flex w-full flex-col items-center justify-center md:pt-12">
          <div className="container flex w-full flex-1 items-center justify-center p-6 pt-12 md:overflow-y-auto">
            {stepIndex === 1 && (
              <>
                {step1Mode === "register" && (
                  <div className="mx-auto flex w-full flex-col justify-center pb-4 md:w-2/3">
                    <h3 className="text-3xl font-bold">
                      {t("Crea tu cuenta de Administrador")}
                    </h3>
                    <span className="my-4 text-left">
                      {t(
                        "Para crear una organización es necesario que te registres como administrador"
                      )}
                    </span>
                    <RegisterForm callback={(e) => handleCallback(e)} />
                    <div className="flex w-full justify-center justify-items-center py-3 text-center">
                      <p>{t("¿Ya tienes una cuenta?")}</p>
                      <a
                        className="primary ml-1 self-center font-semibold"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          router.push({
                            pathname: PUBLIC_ROUTES.vendorSelector.path,
                          })
                        }
                        aria-hidden
                      >
                        {t("Inicia sesión")}
                      </a>
                    </div>

                    <div className="flex w-full items-center justify-center gap-1">
                      <ToggleLang />
                      <ToggleTheme />
                    </div>
                  </div>
                )}

                {step1Mode === "login" && (
                  <div className="mx-auto w-full md:w-2/3">
                    <h3 className="mb-6 text-3xl font-bold">
                      {t("Inicia sesión")}
                    </h3>
                    <LoginForm callback={handleCallback} />
                    <div className="flex w-full justify-center justify-items-center py-3 text-center">
                      <p>{t("¿No tienes cuenta?")}</p>
                      <a
                        className="primary ml-1 self-center font-semibold"
                        style={{ cursor: "pointer" }}
                        onClick={() => setStep1Mode("register")}
                        aria-hidden
                      >
                        {t("¡Regístrate!")}
                      </a>
                    </div>
                    <div className="flex w-full items-center justify-center gap-1">
                      <ToggleLang />
                      <ToggleTheme />
                    </div>
                  </div>
                )}
              </>
            )}

            {stepIndex === 2 && (
              <>
                <div className="h-full w-full">
                  <OrganizationForm callback={handleCallback} />
                </div>
              </>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
}
